var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "history_FILL0_wght400_GRAD0_opsz48",
    d: "M13.933,22a7.6,7.6,0,0,1-5.622-2.344A7.79,7.79,0,0,1,6,13.978H7.333a6.524,6.524,0,0,0,1.911,4.733,6.3,6.3,0,0,0,4.689,1.956,6.462,6.462,0,0,0,4.778-1.978,6.573,6.573,0,0,0,1.956-4.8,6.206,6.206,0,0,0-1.978-4.656,6.619,6.619,0,0,0-4.756-1.9,6.043,6.043,0,0,0-2.833.689A7.727,7.727,0,0,0,8.8,9.844h2.333v1.333H6.489V6.556H7.822V8.911a8.457,8.457,0,0,1,2.744-2.133A7.559,7.559,0,0,1,13.933,6a7.939,7.939,0,0,1,3.133.622,8.211,8.211,0,0,1,2.567,1.7,7.981,7.981,0,0,1,1.733,2.522A7.661,7.661,0,0,1,22,13.956a7.818,7.818,0,0,1-.633,3.133,8.043,8.043,0,0,1-1.733,2.556,8.272,8.272,0,0,1-2.567,1.722A7.818,7.818,0,0,1,13.933,22Zm2.844-4.378-3.422-3.378V9.489h1.333v4.2l3.044,2.978Z",
    transform: "translate(-6 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.43ae0d8c209e0b566b233901e539b861.svg";
export { ForwardRef as ReactComponent };